import { Component, Input, Output } from '@angular/core';

@Component({
    selector: 'std-tooltip',
    template: `
    <div
      [class]="
        'relative flex items-center place-content-center ' + classContainer
      "
    >
      <ng-content select="[content]"></ng-content>
      @if(show){
      <div
        [class]="
          'absolute w-full z-10 bg-green-500 flex place-content-center m-2 min-h-8 item-center ' +
          classTooltip
        "
        [ngClass]="{
          'right-[100%]': position.includes('left'),
          'top-[100%]': position.includes('bottom'),
          'bottom-[100%]': position.includes('top'),
          'left-[100%]': position.includes('right'),
          'rounded-t-lg': !position.includes('bottom'),
          'rounded-b-lg': !position.includes('top'),
          'rounded-r-lg': !position.includes('left'),
          'rounded-l-lg': !position.includes('right'),
        }"
      >
        <!-- <div class="w-2 h-2 bg-blue-500 absolute top-0 left-0"></div> -->
        <ng-content select="[tooltip]"></ng-content>
      </div>
      }
    </div>
  `,
    styles: [],
    standalone: false
})
export class TooltipComponent {
  @Input() classContainer = '';
  @Input() classTooltip = '';
  @Input() position:
    | 'left-bottom'
    | 'left'
    | 'left-top'
    | 'top'
    | 'bottom'
    | 'right-bottom'
    | 'right'
    | 'right-top' = 'top';
  @Input() show: boolean = false;
}
